import * as React from "react";
import { singleton } from "../../../logic/singleton";
const InteractiveContext = React.createContext(true);
export default singleton("views.components.contexts.InteractiveContext", () => InteractiveContext);
